
























import SpecialNavbar from "@/navbars/SpecialNavbar.vue";
import Helper from "../services/errorHelper";
import Component from "vue-class-component";
import Vue from "vue";
import { RawLocation, Route } from "vue-router";
import { namespace } from "vuex-class";
import { logout } from "@/services/Auth2";

const user = namespace("user");

@Component({
  components: {
    SpecialNavbar,
  },
})
export default class ServerError extends Vue {
  beforeRouteLeave(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
  ): void {
    Helper.clear();

    next();
  }

  logout(): void {
    logout();
  }
}
